'use client';

import { ReactNode } from 'react';

interface SessionProviderProps {
  children: ReactNode;
}

export default function SessionProvider({ children }: SessionProviderProps) {
  // Don't use Better Auth SessionProvider for now - causes issues
  // Just render children directly until we fix Better Auth setup
  return <>{children}</>;
}
